let consoleFrontEndDomain = import.meta.env.VITE_CONSOLE_FRONTEND || "*";

export const BXP_CANVAS_BASE_URL = "/working-environments";
export const BXP_CANVAS_ADD_URL = "/add-working-environment";
export const BXP_FSX_STORAGE_CREATE_URL = "/fsxstorage/fsx/create";

export const postReadyMassage = () => {
    if(import.meta.env.MODE === "development" || window.origin.includes("localhost")) {
        window.parent.postMessage({type: 'SERVICE:READY'}, "*");
    } else {
        window.parent.postMessage({type: 'SERVICE:READY'}, consoleFrontEndDomain);
        window.parent.postMessage({type: 'SERVICE:READY'}, import.meta.env.VITE_BLUEXP_FRONTEND);
    }

}

export const postMessageTarget = () => {
    if(import.meta.env.MODE === "development") {
        return "*"
    } else {
        return consoleFrontEndDomain;
    }
}

export const setConsoleFrontEndDomain = (url?: string) => {
    consoleFrontEndDomain = (!!url && url !== "*") ? url.startsWith("http") ? url : `https://${url}` : "*";
}

export const isInIframe = window.top !== window;

export const isInBlueXPIframe = ():boolean => {
    return import.meta.env.VITE_SOURCE === "console";
}
